module.exports = __webpack_public_path__ + "static/media/praying-hands.267b9131.svg";